import React from "react";
import { Form } from "react-bootstrap";
import "./Cliente.component.scss";

const ClienteComponent = ({ cliente }) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Form>
            <Form.Group controlId="formNombre">
              <Form.Label className="text-secondary font-weight-bold">Nombre y Apellido</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nombre y Apellido"
                readOnly={true}
                value={cliente.datos.Nombre}
              />
            </Form.Group>
          </Form>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <Form>
            <Form.Group controlId="formCorreo">
              <Form.Label className="text-secondary font-weight-bold">Correo</Form.Label>
              <Form.Control
                type="text"
                placeholder="Correo"
                readOnly={true}
                value={cliente.datos.Correo}
              />
            </Form.Group>
          </Form>
        </div>
        <div className="col-12 col-md-6">
          <Form>
            <Form.Group controlId="formTelefono">
              <Form.Label className="text-secondary font-weight-bold">Telefono</Form.Label>
              <Form.Control
                type="text"
                placeholder="Telefono"
                readOnly={true}
                value={cliente.datos.Telefono}
              />
            </Form.Group>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ClienteComponent;
